import { useCompanySaleCheck } from "context/useCompanySaleCheck";
import { useOrders } from "context/useOrderData";
import { useProductConfiguration } from "context/useProductConfiguration";
import { WebshopId, WebshopProductModel } from "models/WebShop";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { webShopService } from "services/Services";
import { UrlPath } from "utility/routes";

const LogoDiscountPromo = () => {

    const params = useParams();
    const companyId = params.id ?? "";
    const { companySaleCheck } = useCompanySaleCheck();
    const { saleStatusByCompany } = useOrders();
    const [products, setProducts] = useState<WebshopProductModel[] | undefined>([]);
    const { productConfigurationsByCompany } = useProductConfiguration();

    const path = `${UrlPath.Account.WebShopBase}/${companyId}/${UrlPath.Account.ProductConfig.Logo}`;

    useEffect(() => {
        const getData = async () => {
            const productsList = await webShopService.getProducts();
            if (productsList !== undefined) {
                setProducts(productsList);
            }
        };
        getData();
    }, []);

    if (companyId === "" || companySaleCheck[companyId] === undefined || !companySaleCheck[companyId]?.allowed)
        return <></>;

    const canBuy = companySaleCheck[companyId]?.allowed && !saleStatusByCompany[companyId]?.orderStatuses.some(x => x.activeProducts.some(p => p.id === WebshopId.logo)) && productConfigurationsByCompany[companyId]?.logo === null;

    if (!canBuy)

        return <></>;


    const logo = products?.find(x => x.webShopProductId === 101);

    if (logo === null || logo === undefined || logo?.basePrice === logo?.price)
        return <></>;

    return <div className="card mt-4 cc-card-featured">
        <Link to={path}className="text-dark cc-hover-no-underline">
            <div className="card-header mb-1">
                <h2 className="fs-5">TILBUD! Vis bedriftens logo i ett år for kun kr. {logo?.price},-</h2>
            </div>
            <div className="card-body">
                <img src="/min-bedrift-ill-logo.svg" width="800" height="520" alt="" className="cc-card-shop-promo-ill" style={{ marginTop: 0, maxWidth: "220px" }} />
                <p>Kjøp visning av bedriftens logo i søkeresultatet og på oppføringssiden. Ordinær pris {logo?.basePrice},-</p>
                <p className="mb-0"><span className="btn btn-primary">Kjøp LOGO</span></p>
            </div></Link>
    </div>
    // Black week promo
    // <div className="card mt-4 cc-card-black">
    //     <Link to={path} className="text-dark cc-hover-no-underline" data-galog="black-week|non-paying|display-promo">
    //         <div className="card-header mb-1">
    //             <h2 className="fs-5">BLACK WEEK! {Math.floor(((logo.basePrice - logo.price) / logo.basePrice) * 100)}% rabatt ved kjøp av logo – Nå kun {logo.price},- !</h2>
    //         </div>
    //         <div className="card-body">
    //             <p className="cc-fw-medium">Vis bedriftens logo i søkeresultatet og på oppføringssiden i ett år. Ordinær pris {logo.basePrice},-
    //             </p>
    //             <img src="/min-bedrift-ill-logo.svg" width="800" height="520" alt="" className="cc-card-shop-promo-ill" style={{ marginTop: "10px", maxWidth: "220px" }} />
    //             <ul className="cc-check-list mb-4">
    //                 <li>Skill deg ut og bli gjenkjent i søkeresultatet</li>
    //                 <li>Gi kundene et profesjonelt førsteinntrykk</li>
    //                 <li>Øk tilliten og styrk merkevaren</li>
    //             </ul>
    //             <div className="d-flex flex-column flex-md-row align-items-md-center gap-2">
    //             <p className="mb-0"><span className="btn cc-btn-orange cc-btn-orange-hover-outline">Kjøp LOGO</span></p>
    //             <p className="mb-0">En enkel investering som gir stor synlighet!</p></div>
    //         </div></Link>
    // </div>


    
}

export default LogoDiscountPromo;